import { ref } from "config/constants";
import {   
  UPDATE_FILTER_MEDIAGROUPS,
  UPDATE_FILTER_SEGMENTS,
  UPDATE_FILTER_CATEGORIES,
  UPDATE_FILTER_TARGETS,
  UPDATE_FILTER_SEARCH,
  UPDATE_FILTER_AGE,
  UPDATE_FILTER_GENDER,
  UPDATE_FILTER_REACH,
  UPDATE_FILTER_BUDGET
} from "./types";

export function updateFilterMediagroups(value) {
  return { type: UPDATE_FILTER_MEDIAGROUPS, value };
}

export function updateFilterSegments(value) {
  return { type: UPDATE_FILTER_SEGMENTS, value };
}

export function updateFilterCategories(value) {
  return { type: UPDATE_FILTER_CATEGORIES, value };
}

export function updateFilterTargets(value) {
  return { type: UPDATE_FILTER_TARGETS, value };
}

export function updateFilterSearch(value) {
  console.log('updateFilterSearch', value);
  return { type: UPDATE_FILTER_SEARCH, value };
}

export function updateFilterAge(value) {
  return { type: UPDATE_FILTER_AGE, value };
}

export function updateFilterGender(value) {
  return { type: UPDATE_FILTER_GENDER, value };
}

export function updateFilterReach(value) {
  return { type: UPDATE_FILTER_REACH, value };
}

export function updateFilterBudget(value) {
  return { type: UPDATE_FILTER_BUDGET, value };
}



// WEBPACK FOOTER //
// ./src/data/filters/actions.js